import React from 'react';
import { render } from "react-dom";
import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/mode-javascript";
import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-github";
import "ace-builds/src-noconflict/theme-monokai";
import "ace-builds/src-noconflict/theme-twilight";
import "ace-builds/src-noconflict/ext-language_tools";
import 'ace-builds/webpack-resolver';


import {clone, httpRequest, coreJsonMerge, coreTokenExists, parseFunctions, httpRequestSync, prepareCoreDefinitionSchemaFromCoreMetaData} from './coreFunctions2';
import moment from 'moment';

import { Card, CardContent, CardMedia, CardActionArea, CardActions, CardHeader, Collapse, Backdrop} from '@mui/material';
import { Toolbar, AppBar, IconButton, Button, ButtonBase, Grid, Paper, Accordion, AccordionActions, AccordionDetails, AccordionSummary, Typography, TextField, InputAdornment, MenuItem, Select, FormGroup, Switch, getDrawerUtilityClass, Checkbox, } from '@mui/material';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, TablePagination} from '@mui/material';
import { Badge, CircularProgress, Chip, List, ListItem, ListItemButton, ListItemText, ListItemIcon } from '@mui/material';
import { Tab, Tabs} from '@mui/material';

import {Stepper, Step, StepContent , StepLabel, StepButton, MobileStepper} from '@mui/material';

import { TreeView } from '@mui/x-tree-view/TreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';

import LinearProgress from '@mui/material/LinearProgress';
import { Menu, Modal } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputLabel from '@mui/material/InputLabel';
import { Fab, FormControl, FormControlLabel, FormLabel } from '@mui/material';
import { Dialog, DialogTitle, DialogContent, DialogActions, DialogContentText } from '@mui/material';
import NativeSelect from '@mui/material/NativeSelect';
import {Stack, Skeleton, Slide } from '@mui/material';

import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AddBoxOutlinedIcon from '@mui/icons-material/AddBoxOutlined';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import AppsOutlinedIcon from '@mui/icons-material/AppsOutlined';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import ArrowDropUpOutlinedIcon from '@mui/icons-material/ArrowDropUpOutlined';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import KeyboardArrowUpOutlinedIcon from '@mui/icons-material/KeyboardArrowUpOutlined';
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import AppRegistrationOutlinedIcon from '@mui/icons-material/AppRegistrationOutlined';
import BalanceOutlinedIcon from '@mui/icons-material/BalanceOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import CallToActionOutlinedIcon from '@mui/icons-material/CallToActionOutlined'; 
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import CloseIcon from '@mui/icons-material/Close';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import DryCleaningOutlinedIcon from '@mui/icons-material/DryCleaningOutlined';
import EditIcon from '@mui/icons-material/Edit';
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import EventRepeatOutlinedIcon from '@mui/icons-material/EventRepeatOutlined';
import ExitToAppOutlinedIcon from '@mui/icons-material/ExitToAppOutlined';
import FlashAutoOutlinedIcon from '@mui/icons-material/FlashAutoOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileOpenOutlinedIcon from '@mui/icons-material/FileOpenOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import FilterListOutlinedIcon from '@mui/icons-material/FilterListOutlined';
import FullscreenExitOutlinedIcon from '@mui/icons-material/FullscreenExitOutlined';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import GroupAddOutlinedIcon from '@mui/icons-material/GroupAddOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import GroupRemoveOutlinedIcon from '@mui/icons-material/GroupRemoveOutlined';
import LockOpenOutlinedIcon from '@mui/icons-material/LockOpenOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import MailLockOutlinedIcon from '@mui/icons-material/MailLockOutlined';
import MenuIcon from '@mui/icons-material/Menu';
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoveToInboxOutlinedIcon from '@mui/icons-material/MoveToInboxOutlined';
import NoEncryptionOutlinedIcon from '@mui/icons-material/NoEncryptionOutlined';
import OutboxOutlinedIcon from '@mui/icons-material/OutboxOutlined';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import PreviewOutlinedIcon from '@mui/icons-material/PreviewOutlined';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import SaveIcon from '@mui/icons-material/Save';
import ScaleOutlinedIcon from '@mui/icons-material/ScaleOutlined';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import SettingsIcon from '@mui/icons-material/Settings';
import SyncRoundedIcon from '@mui/icons-material/SyncRounded';
import SimCardDownloadOutlinedIcon from '@mui/icons-material/SimCardDownloadOutlined';
import UploadFileSharpIcon from '@mui/icons-material/UploadFileSharp';

import { Drawer, Divider, Snackbar, Alert } from '@mui/material';
import Form from '@mui/material/FormGroup';
import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';
import Avatar from '@mui/material/Avatar';
import { Box } from '@mui/system';
// import PanelComponent from './panelComponent';
// import FormComponent from './formComponent';
import CoreComponent from './coreComponent';
//import FormLocalComponent from './classes/form_local'

import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import EsLocale from 'moment/locale/es';

import { styled } from '@mui/material/styles';

import { LineChart, Line, Label, LabelList, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, Layer } from 'recharts';
import { BarChart, Bar, AreaChart, Area, PieChart, Pie, Cell} from 'recharts';
import { Radar, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis } from 'recharts';
import { Cross, Curve, Dot, Polygon, Rectangle, Sector, ComposedChart} from 'recharts';

import Webcam from 'react-webcam';
import BarcodeScannerComponent from 'react-qr-barcode-scanner-18';

// import ChatBox from './ChatBox.tsx';
import WebChat from './ChatWrapper.js';

let dynamicComponents = {
    "AceEditor": AceEditor,
    "AdapterMoment": AdapterMoment,
    "EsLocale": EsLocale,
    "AccountBoxOutlinedIcon": AccountBoxOutlinedIcon,
    "AccountCircleIcon": AccountCircleIcon,
    "Accordion": Accordion,
    "AccordionActions": AccordionActions,
    "AccordionDetails": AccordionDetails,
    "AccordionSummary": AccordionSummary,
    "AddBoxOutlinedIcon": AddBoxOutlinedIcon,
    "AppsOutlinedIcon": AppsOutlinedIcon,
    "ArrowDropDownIcon": ArrowDropDownIcon,
    "ArrowLeftIcon": ArrowLeftIcon,
    "ArrowRightIcon": ArrowRightIcon,
    "Alert": Alert,
    "AppBar": AppBar,
    "Backdrop": Backdrop,
    "Badge": Badge,
    "Card": Card, 
    "CardContent": CardContent, 
    "CardMedia": CardMedia, 
    "CardActionArea": CardActionArea, 
    "CardActions": CardActions, 
    "CardHeader": CardHeader,
    "CircularProgress": CircularProgress,
    "Collapse": Collapse,
    "ChevronLeftIcon": ChevronLeftIcon,
    "ChevronRightIcon": ChevronRightIcon,
    "ArrowDownwardIcon": ArrowDownwardIcon,
    "ArrowDropDownOutlinedIcon": ArrowDropDownOutlinedIcon,
    "ArrowDropUpOutlinedIcon": ArrowDropUpOutlinedIcon,
    "ArrowUpwardIcon": ArrowUpwardIcon,
    "Avatar": Avatar,
    "AppRegistrationOutlinedIcon": AppRegistrationOutlinedIcon,
    "BalanceOutlinedIcon": BalanceOutlinedIcon,
    "BorderColorOutlinedIcon": BorderColorOutlinedIcon,
    "Button": Button,
    "ButtonBase": ButtonBase,
    "Box": Box,
    "CallToActionOutlinedIcon": CallToActionOutlinedIcon,
    "CheckOutlinedIcon": CheckOutlinedIcon,
    "Chip": Chip,
    "Drawer": Drawer,
    "DeleteOutlineRoundedIcon": DeleteOutlineRoundedIcon,
    "Menu": Menu,
    "Typography": Typography, 
    "TextField": TextField,
    "Paper": Paper,
    "Grid": Grid,
    "Divider": Divider,
    "Dialog": Dialog,
    "DialogTitle": DialogTitle,
    "DialogContent": DialogContent,
    "DialogActions": DialogActions,
    "DialogContentText": DialogContentText,
    "IconButton": IconButton,
    "InputLabel": InputLabel,
    "Form": FormGroup,
    "FormControl": FormControl,
    "FormControlLabel": FormControlLabel,
    "FormLabel": FormLabel,
    "KeyboardArrowUpOutlinedIcon": KeyboardArrowUpOutlinedIcon,
    "KeyboardArrowDownOutlinedIcon": KeyboardArrowDownOutlinedIcon,
    "LinearProgress": LinearProgress,
    "List": List,
    "ListItem": ListItem,
    "ListItemButton": ListItemButton,
    "ListItemIcon": ListItemIcon,
    "ListItemText": ListItemText,
    "MenuIcon": MenuIcon,
    "Modal": Modal,
    "MoveToInboxOutlinedIcon": MoveToInboxOutlinedIcon,
    "NativeSelect": NativeSelect,
    "Select": Select,
    "Radio": Radio,
    "RadioGroup": RadioGroup,
    "Stack": Stack,
    "Skeleton": Skeleton,

    "AddCircleIcon": AddCircleIcon,
    "SearchIcon": SearchIcon,
    "SettingsIcon": SettingsIcon,
    "SimCardDownloadOutlinedIcon": SimCardDownloadOutlinedIcon,
    "Switch": Switch,
    "CloseIcon": CloseIcon,
    "DateRangeOutlinedIcon": DateRangeOutlinedIcon,
    "DeleteIcon": DeleteIcon,
    "DryCleaningOutlinedIcon": DryCleaningOutlinedIcon,
    "EventRepeatOutlinedIcon": EventRepeatOutlinedIcon,
    "ExitToAppOutlinedIcon": ExitToAppOutlinedIcon,
    "GroupAddOutlinedIcon": GroupAddOutlinedIcon,
    "GroupOutlinedIcon": GroupOutlinedIcon,
    "GroupRemoveOutlinedIcon": GroupRemoveOutlinedIcon,
    "LockOutlinedIcon": LockOutlinedIcon,
    "LockOpenOutlinedIcon": LockOpenOutlinedIcon,
    "LocalShippingOutlinedIcon": LocalShippingOutlinedIcon,
    "MailLockOutlinedIcon": MailLockOutlinedIcon,
    "MenuItem": MenuItem,
    "ModeEditOutlinedIcon": ModeEditOutlinedIcon,
    "EditIcon": EditIcon,
    "EditRoundedIcon": EditRoundedIcon,
    "PowerSettingsNewIcon": PowerSettingsNewIcon,
    "PreviewOutlinedIcon": PreviewOutlinedIcon,
    "OutboxOutlinedIcon": OutboxOutlinedIcon,
    "PowerSettingsNewIcon": PowerSettingsNewIcon,
    "SaveIcon": SaveIcon,
    "FlashAutoOutlinedIcon": FlashAutoOutlinedIcon,
    "FileDownloadOutlinedIcon": FileDownloadOutlinedIcon,
    "FileOpenOutlinedIcon": FileOpenOutlinedIcon,
    "FileUploadOutlinedIcon": FileUploadOutlinedIcon,
    "FilterListIcon": FilterListIcon,
    "FilterListOutlinedIcon": FilterListOutlinedIcon,
    "FullscreenExitOutlinedIcon": FullscreenExitOutlinedIcon,
    "FullscreenOutlinedIcon": FullscreenOutlinedIcon,
    "ScaleOutlinedIcon": ScaleOutlinedIcon,
    "SendIcon": SendIcon,
    "SyncRoundedIcon": SyncRoundedIcon,
    "MoreVertIcon": MoreVertIcon,
    "NoEncryptionOutlinedIcon": NoEncryptionOutlinedIcon ,
    "ExpandMoreIcon": ExpandMoreIcon,
    "ExpandMoreOutlinedIcon": ExpandMoreOutlinedIcon,
    "UploadFileSharpIcon": UploadFileSharpIcon,

    "Tab": Tab, 
    "Tabs": Tabs, 
    "TableContainer": TableContainer,
    "Table": Table,
    "TableHead": TableHead,
    "TableBody": TableBody,
    "TableRow": TableRow,
    "TableCell": TableCell,
    "TablePagination": TablePagination,
    "TreeView": TreeView,
    "TreeItem": TreeItem,
    "ToolBar": Toolbar,
    "Checkbox": Checkbox,
    // "PanelComponent": PanelComponent,
    // "FormComponent": FormComponent,
    "CoreComponent": CoreComponent,
    "LocalizationProvider": LocalizationProvider,
    "TimePicker": TimePicker,
    "DateTimePicker": DateTimePicker,
    "Fab": Fab,
    "Snackbar": Snackbar,
    "Slide": Slide,
    "Img": styled('img')({
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
      }),

    "AreaChart": AreaChart,
    "Area": Area,
    "Bar": Bar,
    "BarChart": BarChart,
    "LineChart": LineChart,
    "Line": Line,
    "Label": Label,
    "LabelList": LabelList,
    "XAxis": XAxis,
    "YAxis": YAxis,
    "CartesianGrid": CartesianGrid,
    "ComposedChart": ComposedChart,
    "Tooltip": Tooltip,
    "Layer": Layer,
    "Legend": Legend,
    "ResponsiveContainer": ResponsiveContainer,
    "PieChart": PieChart,
    "Pie": Pie,
    "Cross": Cross,
    "Curve": Curve, 
    "Dot": Dot, 
    "Polygon": Polygon, 
    "Rectangle": Rectangle, 
    "Sector": Sector,
    "Cell": Cell,
    "Radar": Radar,
    "RadarChart": RadarChart,
    "PolarGrid": PolarGrid,
    "PolarAngleAxis": PolarAngleAxis,
    "PolarRadiusAxis": PolarRadiusAxis,
    "Webcam": Webcam,
    "BarcodeScannerComponent": BarcodeScannerComponent,
    "MobileStepper": MobileStepper,
    "Stepper": Stepper,
    "Step": Step, 
    "StepContent": StepContent,
    "StepLabel" : StepLabel,
    "StepButton": StepButton,
    // "ChatBox": ChatBox,
    "WebChat": WebChat
  };

  // const compatibiltyComponents = {
  //   "Typography": Typography, 
  //   "Input": TextField,
  //   "Button": Button,
  //   "Paper": Paper,
  //   "Grid": Grid,
  //   "Box": Box,
  //   "InputLabel": InputLabel,
  //   "Form.Item": FormControl,
  //   "NativeSelect": NativeSelect,
  //   "Select": Select,
  //   "MenuItem": MenuItem,
  //   "SaveIcon": SaveIcon,
  //   "SendIcon": SendIcon,
  //   "ExpandMore": ExpandMore,
  //   "PanelComponent": PanelComponent,
  //   "FormComponent": FormComponent
  // };

  export function getMaterialUIComponent(rootComponent, component, _item, _children2, rowProps){
    const MaterialUIComponent = dynamicComponents[_item.name];
    if (MaterialUIComponent === undefined){        
        console.error("No tengo definición de componente dinámico MaterialUI para " + _item.name);
    }    
    
    if (_item.raw){
        return MaterialUIComponent;
    }else{
        return <MaterialUIComponent {...rowProps}>{_item.content}{_children2}</MaterialUIComponent>;
    }
  }

  export async function getMUIComponent(component, requestSchema){
    let _component = "";
    let _rowProps = {};
    let _content = null;
    let _children = null;

    let _componentContent = {};
    if (component.jsonSchema){
        _component = coreTokenExists(component.jsonSchema, "options.mainComponent") ? component.jsonSchema.options.mainComponent : "CoreComponent";
        _rowProps = clone(component);
    }else{
        _component = component.name;
        _rowProps = component.props;
        _content = component.content ?? null;
        _children = component.children ?? null;
    }

    if (dynamicComponents[_component] === undefined || (dynamicComponents[_component].toString() === '[object Promise]' || dynamicComponents[_component].toString() === '[object IDBOpenDBRequest]' || dynamicComponents[_component].toString() === '[object IDBRequest]')){
        let loaded = await InitializeMUIComponent(_component, true, requestSchema);
        if (!loaded){
            console.error("No tengo definición de componente dinámico MaterialUI para " + _component);
            return null;
        }
    }    
    const MaterialUIComponent = (dynamicComponents[_component] === undefined) ? null : dynamicComponents[_component];
    
    
    if (component.raw){
        return MaterialUIComponent;
    }else{
        if (_component === "DateTimePicker"){
            // console.log("opa");
            let _params = null;
            if (_rowProps.value === ""){
                _rowProps.value = null;
            }else{
                _rowProps.value = new moment(_rowProps.value);
            }

            if (_rowProps.renderInputParams){
                let _params = _rowProps.renderInputParams;
                _rowProps.renderInput = (_params) => <TextField {..._params} />;
                delete _rowProps.renderInput;
            }
            return <MaterialUIComponent {..._rowProps} renderInput = {(_params) => <TextField {..._params} />}>{_content}{_children}</MaterialUIComponent>;
        }
        else{
            // if (_component === "Grid" && _rowProps !== null){                
            //     console.log("opa con rowprops: " + JSON.stringify(_rowProps));
            // }
            if (typeof _content === "function"){
                _content = _content();
            }
            if (typeof _children === "function"){
                _children = _children();
            }
            if (_content !== null){
                _componentContent = _content;
            }else{
                _componentContent = _children;
            }

            // if (["TextField", "Select"].indexOf(_component) !== -1 && (_rowProps.value === null ||  _rowProps.value === undefined)){
            //     //_rowProps.value = "";
            //     _rowProps.value = _rowProps.type === "number" ? 0 : "";
            // }

            if (["TextField", "Select"].indexOf(_component) !== -1){
                if (_rowProps.type === "number"){
                    if (_rowProps.inputProps === undefined){
                        _rowProps.inputProps = {};
                    }
                    _rowProps.type = "text";
                    //_rowProps.inputProps.pattern ="[-+]?[0-9]*[.,]?[0-9]+";
                    _rowProps.inputProps.step = "0.1";
                    _rowProps.inputProps.lang = "en-US";
                    if (_rowProps.value === undefined || _rowProps.value === ""){
                        _rowProps.value = 0;
                    }
                }else{
                    if (_rowProps.value === null ||  _rowProps.value === undefined){
                        _rowProps.value = "";
                    }
                }
            } 

            if (["Switch"].indexOf(_component) !== -1 && (_rowProps.checked === "" || _rowProps.checked === undefined || _rowProps.checked === null)){
                _rowProps.checked = false;
            }

            return <MaterialUIComponent {..._rowProps}>{_componentContent}</MaterialUIComponent>;            
        }
    }
  }

export async function InitializeMUIComponent(componentName, waitForResponse, requestSchema){

    if (waitForResponse === null || waitForResponse === undefined){
        waitForResponse = true;
    }

    let _componentsDB;
    if (dynamicComponents[componentName] === undefined || dynamicComponents[componentName] === null){
        
        //Me fijo si lo tengo cacheado.
        // Esto después lo tengo que sacar todo xa afuera.       
        const wpaName = window.backendBaseUrl.substring(8).split('.')[0];
 
        const request = window.indexedDB.open(wpaName, 1);
        dynamicComponents[componentName] = request;

        request.onerror = (event) => {
            console.error("Error al abrir la base de datos con event: " + event);
        };

        let fetchData = () => {
            console.log("Voy a buscar definición para el componente dinámico MaterialUI para " + componentName);
            let _requestSchema = (requestSchema !== null && requestSchema !== undefined) ? clone(requestSchema) : {"url": "CoreMetaData/GetSchema", "type": "GET"};
            _requestSchema.url+= "/"+componentName;

            let BaseComponent;
            dynamicComponents[componentName] = httpRequestSync(null, _requestSchema, null)
                .then(async (_componentSchema) => {
                    // console.log("Estoy en el then del componente " + componentName + " con valor: " + _componentSchema)
                    if (_componentSchema.status !== 200){
                        console.error("No se encontró esquema xa: " + componentName + ". " + _componentSchema.data.Message);
                        dynamicComponents[componentName] = null;
                        return null;
                    }
            
                    let jsonSchema = prepareCoreDefinitionSchemaFromCoreMetaData(_componentSchema.data);
                    if (jsonSchema.coreDefinition){
                        if (dynamicComponents[jsonSchema.name] === undefined || (dynamicComponents[componentName].toString() === '[object Promise]' || dynamicComponents[componentName].toString() === '[object IDBOpenDBRequest]' || dynamicComponents[componentName].toString() === '[object IDBRequest]')){
                            if (!(await InitializeMUIComponent(jsonSchema.name))){
                                console.error("Error al agregar el componente: " + jsonSchema.name)
                            }
                        }
                        //Es un componente que hereda a otro así que hago la extensión de la clase
                        BaseComponent = dynamicComponents[jsonSchema.name];
                        dynamicComponents[componentName] = class ExtendedComponent extends BaseComponent {
                            constructor(props){
                                super(props);
                                this.coreDefinition = coreJsonMerge(this.coreDefinition, jsonSchema.coreDefinition);
                            }
                        };
                        let exceptions = ["datacomponent", "dataheadercellcomponent", "testdata", "datapanelcomponent", "formfiltercomponent", "genericformcomponent", "formcomponent"];
                        //if (exceptions.indexOf(componentName.toLowerCase()) === -1){
                            const transaction = _componentsDB.transaction(["components"], "readwrite");
                            const componentsObjectStore = transaction.objectStore("components");            
                            const _addResult = componentsObjectStore.add({
                                id: componentName.toLowerCase(),
                                componentSchema: _componentSchema.data
                            });
                            _addResult.onsuccess = (evt) => {console.log("agregado el componente " + componentName + " evt: " + evt)};
                        //}
                    }
                })
                .catch((response) => {
                    let _message = response.message ?? response.response.data.Message;
                    console.error("No se encontró esquema xa: " + componentName + ". " + _message);
                    console.log(response);
                    return null;
                });
        };

        let getData = () => {
            const transaction = _componentsDB.transaction(["components"], "readwrite");
            const componentsObjectStore = transaction.objectStore("components");
            const componentDBObject = componentsObjectStore.get(componentName.toLowerCase());
            dynamicComponents[componentName] = componentDBObject;
            componentDBObject.onerror = (event) => {
                fetchData();
            };

            componentDBObject.onsuccess = async (event) => {
                if (event.target.result === undefined){
                    fetchData();
                }else{
                    let jsonSchema = prepareCoreDefinitionSchemaFromCoreMetaData(event.target.result.componentSchema);
                    if (jsonSchema.coreDefinition){
                        if (dynamicComponents[jsonSchema.name] === undefined || (dynamicComponents[componentName].toString() === '[object Promise]' || dynamicComponents[componentName].toString() === '[object IDBOpenDBRequest]' || dynamicComponents[componentName].toString() === '[object IDBRequest]')){
                            if (!(await InitializeMUIComponent(jsonSchema.name))){
                                console.error("Error al agregar el componente: " + jsonSchema.name)
                            }
                        }
                        //Es un componente que hereda a otro así que hago la extensión de la clase
                        let BaseComponent = dynamicComponents[jsonSchema.name];
                        dynamicComponents[componentName] = class ExtendedComponent extends BaseComponent {
                            constructor(props){
                                super(props);
                                this.coreDefinition = coreJsonMerge(this.coreDefinition, jsonSchema.coreDefinition);
                            }
                        };
                    }
                    // console.log("Traje " + componentName + " desde el caché");
                }
            };
        };

        request.onsuccess = (event) => {
            _componentsDB = event.target.result;
            if (!_componentsDB.objectStoreNames.contains("components")) {
                // Create an objectStore for this database
                const objectStore = _componentsDB.createObjectStore("components", { keyPath: "id" });
            }
            getData();
        };
        // This event is only implemented in recent browsers
        request.onupgradeneeded = (event) => {
            // Save the IDBDatabase interface
            _componentsDB = event.target.result;
        
            // Create an objectStore for this database
            const objectStore = _componentsDB.createObjectStore("components", { keyPath: "id" });
        };
  

        /////-------------------------------------------------------

        
    }

    if (waitForResponse){
        while (dynamicComponents[componentName] !== undefined && dynamicComponents[componentName] !== null && (dynamicComponents[componentName].toString() === '[object Promise]' || dynamicComponents[componentName].toString() === '[object IDBOpenDBRequest]' || dynamicComponents[componentName].toString() === '[object IDBRequest]')){
            //console.log("se está cargando el componente " + componentName + " ... espero a ver si termina");
            await new Promise(resolve => setTimeout(resolve, 10));
        }
    }

    // console.log("Termine de cargar el componente " + componentName + " con valor: " + dynamicComponents[componentName])
    if (dynamicComponents[componentName] !== null || dynamicComponents[componentName] === undefined){
        return true;
    }else{
        delete dynamicComponents[componentName];
        return false;
    }
}

export async function deleteComponentFromCache(key){
    let _componentsDB;
    const wpaName = window.backendBaseUrl.substring(8).split('.')[0];

    const request = window.indexedDB.open(wpaName, 1);
    dynamicComponents[key] = undefined;

    request.onerror = (event) => {
        console.error("Error al abrir la base de datos con event: " + event);
    };

    request.onsuccess = (event) => {
        _componentsDB = event.target.result;
        const transaction = _componentsDB.transaction(["components"], "readwrite");
        const componentsObjectStore = transaction.objectStore("components");            
        const _addResult = componentsObjectStore.delete(key.toLowerCase());
        _addResult.onsuccess = (evt) => {console.log("Borrado el componente " + key + " evt: " + evt)};
    };

}

export async function xInitializeMUIComponent(componentName, waitForResponse){

    if (waitForResponse === null || waitForResponse === undefined){
        waitForResponse = true;
    }

    if (dynamicComponents[componentName] === undefined){  
        // console.log("Voy a buscar definición para el componente dinámico MaterialUI para " + componentName);
        let requestSchema = {"url": "CoreMetaData/GetSchema/"+componentName, "type": "GET"};
        let BaseComponent;
        dynamicComponents[componentName] = httpRequestSync(null, requestSchema, null)
            .then(async (_componentSchema) => {
                // console.log("Estoy en el then del componente " + componentName + " con valor: " + _componentSchema)
                if (_componentSchema.status !== 200){
                    console.error("No se encontró esquema xa: " + componentName + ". " + _componentSchema.response.data.Message);
                    return null;
                }
        
                let jsonSchema = prepareCoreDefinitionSchemaFromCoreMetaData(_componentSchema.data);
                if (jsonSchema.coreDefinition){
                    if (dynamicComponents[jsonSchema.name] === undefined || dynamicComponents[jsonSchema.name].toString() === '[object Promise]'){
                        if (!(await InitializeMUIComponent(jsonSchema.name))){
                            console.error("Error al agregar el componente: " + jsonSchema.name)
                        }
                    }
                    //Es un componente que hereda a otro así que hago la extensión de la clase
                    BaseComponent = dynamicComponents[jsonSchema.name];
                    dynamicComponents[componentName] = class ExtemdedComponent extends BaseComponent {
                        constructor(props){
                            super(props);
                            this.coreDefinition = coreJsonMerge(this.coreDefinition, jsonSchema.coreDefinition);
                        }
                    };
                }
            })
            .catch((response) => {
                let _message = response.message ?? response.response.data.Message;
                console.error("No se encontró esquema xa: " + componentName + ". " + _message);
                return null;
            });
    }

    if (waitForResponse){
        while (dynamicComponents[componentName].toString() === '[object Promise]'){
            // console.log("se está cargando el componente " + componentName + " ... espero a ver si termina");
            await new Promise(resolve => setTimeout(resolve, 300));
        }
    }

    // console.log("Termine de cargar el componente " + componentName + " con valor: " + dynamicComponents[componentName])
    if (dynamicComponents[componentName] !== null){
        return true;
    }else{
        delete dynamicComponents[componentName];
        return false;
    }
}